import classNames from 'classnames';
import Image, {
  Props as ImgProps
} from '../../Atoms/Image';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';

export interface Props {
  title: string;
  subtitle: string;
  text: string | JSX.Element;
  img: ImgProps;
  time?: string;
  className?: string;
}

function ChatMessage({
  title,
  subtitle,
  text,
  img,
  time,
  className
}: Props) {
  return (
    <div
      className={classNames([
        'group flex flex-col gap-5 even:ml-auto sm:gap-7 md:flex-row' +
          ' md:even:flex-row-reverse',
        className
      ])}
    >
      <div className="h-16 w-16 overflow-hidden rounded-full group-even:ml-auto md:h-28 md:w-28 lg:h-44 lg:w-44">
        <Image {...img} />
      </div>
      <div className="w-auto max-w-lg text-left group-even:text-right">
        <Title
          as="h3"
          size={5}
          weight={700}
          color="inherit"
          className="mb-2"
        >
          {title}
        </Title>
        <Text
          font="circular"
          color="inherit"
          className="mb-4"
        >
          {subtitle}
        </Text>
        <div className="flex flex-col gap-7 rounded-xl rounded-br-[40px] bg-white p-7 text-left shadow-light-blue-xs group-even:rounded-br-xl group-even:rounded-bl-[40px] sm:flex-row sm:group-even:flex-row-reverse">
          <Text size="base">
            <span>{text}</span>
          </Text>

          {time && (
            <div className="ml-auto w-auto whitespace-nowrap">
              <Text size="xs" color="gray">
                {time}
              </Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatMessage;
